import Vue from 'vue'
import Router from 'vue-router'
import firebaseApp from '@/plugins/firebase.js'
import { getAuth } from 'firebase/auth'
import config from './../../conf.json'
import store from '@/vuex/store'

Vue.component('loading', { template: '<div>Loading!</div>' })

// Global
const Base = () => import('@/modules/global/views/Base')
const Home = () => import('@/modules/general/home/views/Home')
const Page404 = () => import('@/modules/global/views/Page404')
const PageAccessDenied = () => import('@/modules/global/views/PageAccessDenied')
const Maintenance = () => import('@/modules/global/views/MaintenancePage')

// Full maintenance mode — only active for BEDSTpension when flag is set in conf.json
const maintenanceActive = config.customization.name == 'BEDSTpension' && config.customization.maintenance === true
const Rapport = () => import('@/modules/general/rapport/views/Rapport')

// LoginRouter
import LoginRouter from '@/modules/general/login/router/router'

// SignUpRouter
import SignUpRouter from '@/modules/general/signup/router/router'

// CompanyRouter
import CompanyRouter from '@/modules/general/company/router/router'

// CompanyRouter
import ResignedCompanyRouter from '@/modules/general/resignedCompany/router/router'

// EmployeeRouter
import EmployeeRouter from '@/modules/general/employee/router/router'

// SupplierRouter
import SupplierRouter from '@/modules/general/supplier/router/router'

// Profile
import User from '@/modules/general/user/router/router'

import i18n from '@/plugins/i18n'

Vue.use(Router)

var router = new Router({
	mode: 'history',
	routes: [
		{
			path: '/maintenance',
			name: 'Maintenance',
			component: Maintenance,
			meta: {
				title: 'Vedligeholdelse',
			},
		},
		{
			path: '/',
			redirect: '/login',
			component: Base,
			children: [
				{
					path: '/home',
					name: 'Home',
					component: Home,
					meta: {
						requiresLoggedIn: true,
						title: i18n.t('browserTitle.home'),
					},
				},
				{
					path: '/404',
					name: 'Page404',
					component: Page404,
					meta: {
						title: i18n.t('browserTitle.404'),
					},
				},
				{
					path: '/accessdenied',
					name: 'AccessDenied',
					component: PageAccessDenied,
					meta: {
						requiresLoggedIn: true,
						title: i18n.t('browserTitle.accessdenied'),
					},
				},
				...LoginRouter,
				...SignUpRouter,
				...CompanyRouter,
				...ResignedCompanyRouter,
				...EmployeeRouter,
				...SupplierRouter,
				...User,
				{
					path: '/rapport',
					name: 'Rapport',
					component: Rapport,
					meta: {
						requiresLoggedIn: true,
						action: 'read',
						resource: 'Report',
						title: 'Rapport',
					},
				},
				{
					path: '/tasks',
					name: 'TasksOverview',
					component: () => import('@/modules/general/tasks/views/TasksOverview'),
					meta: {
						requiresLoggedIn: true,
						action: 'read',
						resource: 'CompanyLogs',
						title: 'Opgaver',
					},
				},
			],
		},
	],
})

router.beforeEach(async (to, from, next) => {
	// Full maintenance mode: block everything (incl. login) and force the maintenance page
	if (maintenanceActive) {
		if (to.name == 'Maintenance') {
			next()
		} else {
			next({ name: 'Maintenance' })
		}
		return
	} else if (to.name == 'Maintenance') {
		// Not in maintenance mode — keep the page unreachable
		next({ name: 'Login' })
		return
	}

	document.title = config.customization.footerName
		? to.meta.title + ' | ' + config.customization.footerName
		: to.meta.title || config.customization.name || ''
	let requiresNotLoggedIn = to.matched.some((record) => record.meta.requiresNotLoggedIn)
	let requiresLoggedIn = to.matched.some((record) => record.meta.requiresLoggedIn)
	var user = store.getters['auth/user']
	var ability = store.getters['auth/ability']

	let canNavigate = true

	if (to.meta.action && to.meta.resource) {
		canNavigate = ability.can(to.meta.action || 'read', to.meta.resource, to.meta.params) // Casl router restriction
	}

	if (requiresLoggedIn) {
		// Logged in
		if (!user) {
			// Not logged in
			router.push({
				name: 'Login',
				query: { redirect: to.fullPath },
			})
		} else if (user) {
			if (to.name == 'AccessDenied') {
				next()
			} else if (!canNavigate) {
				router.push({
					name: 'AccessDenied',
				})
			} else {
				next()
			}
		}
	} else if (requiresNotLoggedIn) {
		console.log('requiresNotLoggedIn')
		// Not logged in
		if (!user) {
			next()
		} else if (user) {
			router.push({
				name: 'Companies',
			})
		}
	} else {
		next()
	}
})

export default router
